import styled from "styled-components";

export const Galery = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  background-color: black;
`;

export const Item = styled.img`
  /* width: 30%; */
`;

export const Boundry = styled.div`
  /* width: 30%;
    border: 2px solid black;

    @media screen and (max-width: 950px){
        width: 50%;
    } */
`;
export const Desc = styled.div`
  height: 20%;
`;
